import React from "react";
import styles from "../../styles";
import { editorStyles } from "./style.js";
import { Controlled as CodeMirror } from "react-codemirror2";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./style.css";
import { DisplayModes } from "../IDE";
require("codemirror/mode/xml/xml");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/css/css");
require("codemirror/mode/jsx/jsx");

class CodeEditor extends React.Component {
  constructor(props) {
    super(props);
    this.MODES = {
      JS: { value: "javascript", label: "JavaScript" },
      JSX: { value: "jsx", label: "JSX" },
      HTML: { value: "xml", label: "HTML" },
      CSS: { value: "css", label: "CSS" },
      NULL: { value: "null", label: "Plain" },
    };
    this.state = {
      line: 0,
      col: 0,
      mode: this.MODES.HTML.value,
      cmd: "",
    };
    this.onCursorActivity = this.onCursorActivity.bind(this);
    this.dropDownSelect = this.dropDownSelect.bind(this);
    this.changeCmd = this.changeCmd.bind(this);
    this.executeCmd = this.executeCmd.bind(this);
    this.highlight = this.highlight.bind(this);
    this.unhighlight = this.unhighlight.bind(this);
  }

  componentDidMount() {
    const editor = document.getElementsByClassName(
      this.props.id + "_codebox"
    )[0];
    editor.style.flex = 1;
    const frame = editor.children[0];
    frame.style.height = String(this.props.height - 30) + "px";
    editor.addEventListener("keydown", (e) => {
      if (e.ctrlKey) {
        if (e.which === 83) {
          e.preventDefault();
          this.props.saveFile();
        }
        return false;
      }
    });
  }

  onCursorActivity = (editor) => {
    const cursorPos = editor.getCursor();
    this.setState((state) => ({
      ...state,
      line: cursorPos.line,
      col: cursorPos.ch,
    }));
  };

  dropDownSelect = (sel) => {
    this.setState((state) => ({
      ...state,
      mode: sel.value,
    }));
  };

  changeCmd = (e) => {
    this.setState((state) => ({
      ...state,
      cmd: e.target.value,
    }));
  };

  executeCmd(e) {
    if (e.key === "Enter") console.log(this.state.cmd);
  }

  highlight(e) {
    e.target.style.opacity = 0.8;
  }

  unhighlight(e) {
    e.target.style.opacity = 1;
  }

  render() {
    const dropDownOptions = Object.keys(this.MODES).map(
      (key) => this.MODES[key]
    );
    return (
      <div
        style={{
          ...styles.column,
          width: this.props.width,
          height: this.props.height,
          ...editorStyles.frame,
        }}
      >
        {this.props.width > 300 && (
          <div style={editorStyles.menuBar}>
            <div style={editorStyles.cursorInfo}>
              <div>{"Ln " + this.state.line + ", Col " + this.state.col}</div>
            </div>
            <div style={editorStyles.title}>
              {this.props.title + (this.props.saved ? " ●" : " ○")}
            </div>
            <div style={editorStyles.dropDown}>
              <Dropdown
                options={dropDownOptions}
                onChange={this.dropDownSelect}
                value={this.state.mode}
                placeholder={"Language"}
              />
            </div>
          </div>
        )}
        <CodeMirror
          className={this.props.id + "_codebox"}
          value={this.props.value}
          options={{
            mode: this.state.mode,
            theme: "material",
            lineNumbers: true,
            autoRefresh: true,
          }}
          editorDidMount={(editor) => {
            this.instance = editor;
            setTimeout(() => this.instance.refresh(), 0);
          }}
          onBeforeChange={this.props.onBeforeChange}
          onChange={this.props.onChange}
          onCursorActivity={this.onCursorActivity}
        />
        <div style={editorStyles.menuBar}>
          <input
            style={{
              ...editorStyles.inputBox,
              width: this.props.width - 120,
            }}
            value={this.state.cmd}
            onChange={this.changeCmd}
            onKeyDown={this.executeCmd}
            placeholder={"Enter Command"}
          />
          <div
            style={{ ...editorStyles.menuButton, width: 70 }}
            onClick={() => this.props.changeDisplayMode(DisplayModes.PREVIEW)}
            onMouseOver={this.highlight}
            onMouseOut={this.unhighlight}
          >
            Preview
          </div>
          <div
            style={{ ...editorStyles.menuButton, width: 70 }}
            onClick={() => this.props.changeDisplayMode(DisplayModes.CONSOLE)}
            onMouseOver={this.highlight}
            onMouseOut={this.unhighlight}
          >
            Console
          </div>
        </div>
      </div>
    );
  }
}

export default CodeEditor;
